import { Component, OnInit } from '@angular/core';
import { ControlContainer, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: '[formGroup] section-contact, [formGroupName] section-contact',
  templateUrl: './contact.component.html',
})
export class ContactComponent implements OnInit {
  public contactFromGroup: UntypedFormGroup;

  constructor(private controlContainer: ControlContainer) {}

  ngOnInit() {
    this.contactFromGroup = this.controlContainer.control as UntypedFormGroup;
  }
}
